import { render, staticRenderFns } from "./img_load.vue?vue&type=template&id=2da469cd&scoped=true&"
import script from "./img_load.vue?vue&type=script&lang=js&"
export * from "./img_load.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da469cd",
  null
  
)

export default component.exports